import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Tour from 'reactour'
import {
  selectCountries,
  selectCountriesOnly,
  selectGuideList,
  selectGuideListByKey,
} from 'stores/config/config.selector'
import {
  getIsGuideByKey,
  GUIDE_TYPE_ENUM,
  handleUpgrade,
  setIsGuideByKey,
} from 'utils/helper'
import ListCampaignComponent from '../../components/ListCampaign'
import Loading from '../../components/Loading'
import types from '../../constants/types'
import MainLayout from '../MainLayout'
import AccountInfo from './items/AccountInfo'
import ChartDashboard from './items/Chart'
import DashboardChart from './items/Chart/Dashboard'
import DashboardV2 from './items/DashboardV2'
import DialogAlertPoints from './items/DialogAlertPoints'
import PricingModal from 'components/Modals/PricingModal'
import OnboardingModal from './items/OnboardingModal'
import Introduce from './items/Introduce'
import MessengerButton from './items/MessengerButton'
import DailyBannerModal from '../../components/DailyBannerModal'
import ScenarioManagement from '../../components/ListScenario'
import FiltersContainer from '../../components/FiltersContainer'
import moment from 'moment'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { showError } from 'stores/alert/slice.alert'
// import CampaignChart from './items/Chart/Campaign'

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'red',
  },
  sidebar: {
    width: 250,
    float: 'left',
    height: '100vh',
    overflowY: 'auto',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    background: 'white',
  },
  wrapperCampaignHistory: {
    borderRadius: 20,
  },
  contentRight: {
    width: "calc(100vw - 265px)",
    float: "right",
    backgroundColor: "#ffffff"
  },
  account: {
    display: 'flex',
    alignItems: 'center',
    background: '#f0f0f0',
    padding: 15,
  },
  userName: {
    fontWeight: 'bold',
  },
  right: {
    marginLeft: 15,
  },
  wrapAccount: {
    padding: 15,
  },
  form: {
    width: '100%',
    // "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
    //   transform: "translate(0px, -20px) scale(0.9) !important",
    //   overflow: "hidden !important",
    //   "-moz-box-sizing": "border-box !important",
    //   "-webkit-box-orient": "vertical !important",
    //   "-webkit-box-sizing": "border-box !important",
    //   "-webkit-line-clamp": "1 !important",
    //   display: "-webkit-box !important",
    //   /* padding: 0px 20px; */
    // },
    // "& .MuiInputLabel-filled": {
    //   transform: "translate(0px, -20px) scale(0.9) !important",
    //   overflow: "hidden !important",
    //   "-moz-box-sizing": "border-box !important",
    //   "-webkit-box-orient": "vertical !important",
    //   "-webkit-box-sizing": "border-box !important",
    //   "-webkit-line-clamp": "1 !important",
    //   display: "-webkit-box !important",
    //   /* padding: 0px 20px; */
    // },
    // "& .MuiFilledInput-input": {
    //   padding: "10px 12px 10px 2px",
    // },
    // "& .MuiAutocomplete-root": {
    //   marginTop: "30px !important",
    //   marginBottom: "30px !important",
    // },
  },
  input: {
    marginBottom: 15,
  },
  button: {
    marginTop: 0,
  },
  buttonVerify: {
    width: 300,
    margin: '5px auto',
  },
  textField: {
    margin: '30px 0px 5px 0px !important',
  },
  select: {
    margin: '10px 0px !important',
  },
  formVerify: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30,
    marginBottom: 30,
    '& $textField': {
      width: 330,
    },
    '& button': {
      margin: '0px 0px 0px 15px',
    },
  },
  number: {
    fontWeight: 'bold',
  },
  wrapSelectLabel: {
    zIndex: 1,
    fontSize: 16,
    paddingLeft: 10,
    marginTop: -5,
    '&.MuiFormLabel-filled': {
      display: 'none !important',
    },
    '&.Mui-focused': {
      display: 'none !important',
    },
  },
  wrapperMain: {
    paddingRight: "0",
  },
  wrapperBoxInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px 15px 15px 0px',
  },

  boxInfoCampaign: {
    background: '#FF5757',
    '& h3': {
      background: '#FF7979',
    },
    '& $link': {
      background: '#E64F4F',
      lineHeight: 0.8,
    },
  },

  wrapperTable: {
    width: '100%',
  },
  error: {
    margin: '0px',
    fontSize: '13px',
    color: 'red',
    marginTop: '4px',
    marginLeft: '4px',
  },
  errorCode: {
    margin: '10px 0px 0px 10px',
    fontSize: '14px',
    color: 'red',
    textAlign: 'center',
  },
  wrapAutocomplete: {
    marginTop: 10,
    '& .MuiAutocomplete-inputRoot': {
      height: 'auto',
    },
  },
}))

const HomeView = (props) => {
  const {
    getAccount,
    onVerifyNumberPhone,
    onGetOtp,
    verifyNumberPhone,
    user,
    onWhatYouNeed,
    onDashboard,
    share,
    dashboard,
    getCampaign,
    campaign,
    verifyNumberPhoneError,
    onVerifyNumberPhoneVoice,
    updateUser,
    loading,
  } = props
  const classes = useStyles()
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [fullPhone, setFullPhone] = useState('')
  const [email, setEmail] = useState('')
  const [company, setCompany] = useState('')
  const [business, setBusiness] = useState([])
  const [country, setCountry] = useState()
  const [giftPoints, setGiftPoints] = useState(0)
  const [isAlertPoints, setIsAlertPoints] = useState(true)
  const [openPricing, setOpenPricing] = useState(false)

  const [province, setProvince] = useState('')
  const [isInfo, setIsInfo] = useState(true) // true
  const [isVerify, setIsVerify] = useState(false)
  const [nameError, setNameError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [countryError, setCountryError] = useState('')
  const [phoneDialCode, setPhoneDialCode] = useState('+84')
  // const [proviceError, setProviceError] = useState("");
  const [isVisibleIntroduce, setIsVisibleIntroduce] = useState(true)
  const [uid, setUID] = useState('')
  const tourOverview = useSelector(
    selectGuideListByKey(GUIDE_TYPE_ENUM.overview)
  )
  const [tourConfig, setTourConfig] = useState(null)
  const { t, i18n } = useTranslation()

  const countriesOnly = useSelector(selectCountriesOnly)
  const countries = useSelector(selectCountries)
  const dispatch = useDispatch()
  const isNavigateUpdateRef = useRef()
  const [isShowDashboardTooltip, setIsShowDashboardTooltip] = useState(false)

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0]
  )
  const [dailyData, setDailyData] = useState({})

  const [selectedFilter, setSelectedFilter] = useState('LAST_1M')

  const history = useHistory()

  const handleFilterChange = (filter) => {
    if (filter === 'ALL') {
      history.push({
        pathname: `/quan-ly-chien-dich`,
      })
    }

    setSelectedFilter(filter)
  }

  useEffect(() => {
    const dateData = dashboard.dailyData?.find(
      (item) => item.date === selectedDate
    )
    if (dateData) {
      setDailyData(dateData)
    } else {
      setDailyData({
        totalCus: 0,
        totalSent: 0,
        totalSuccess: 0,
        totalFail: 0,
      })
    }
  }, [selectedDate, dashboard])

  useEffect(() => {
    checkAlert()
    if (verifyNumberPhone) {
      setIsInfo(false)
      setIsVerify(false)
    }
  }, [verifyNumberPhone])
  /* End Off veriry phone */

  useEffect(() => {
    if (user?.id) {
      const url_string = window.location.href //window.location.href
      const url = new URL(url_string)
      const ref = url.searchParams.get('ref')
      const event = url.searchParams.get('event')

      if (
        event == 'upgrade' &&
        ref == 'extension' &&
        !isNavigateUpdateRef.current
      ) {
        isNavigateUpdateRef.current = true
        setOpenPricing(true)
      }
    }
  }, [user])

  useEffect(() => {
    if (country) {
      const selectedCountry = countries.find((item) => item.countryName === country);
      if (selectedCountry) {
        setPhoneDialCode(selectedCountry.dial_code);
      }
    }
  }, [country]);

  useEffect(() => {
    onDashboard()
  }, [])

  useEffect(() => {
    const params = {
      page: types.PAGINATION.PAGE,
      size: 50,
      sort: 'createdAt,desc',
    }
    getCampaign(params)
  }, [])

  /* not veriry phone */
  useEffect(() => {
    if (user) {
      if (user?.name || getAccount?.name) {
        setName(user.name || getAccount.name)
      }
      if (user?.email || getAccount?.email) {
        setEmail(user.email || getAccount.email)
      }
      if (user?.phone || getAccount?.phone) {
        let rawPhone = user?.phone || getAccount?.phone
        // tạm thoi
        if (/^0/g.test(rawPhone)) {
          rawPhone = rawPhone.replace(/^0/g, '+84')
        }
        setPhone(rawPhone)

        // Extract dial code and phone number based on current phoneDialCode
        if (rawPhone.startsWith('+')) {
          const matchDialCode = rawPhone.match(/^\+\d{1,4}/);
          if (matchDialCode) {
            setPhoneDialCode(matchDialCode[0]);
            setPhoneNumber(rawPhone.substring(matchDialCode[0].length).replace(/^0/g, ''));
          } else {
            setPhoneNumber(rawPhone);
          }
        } else {
          setPhoneNumber(rawPhone);
        }
      }
      // setBusiness(user?.business);
      setCompany(user?.company || '')

      setUID(user?.id)
      if (user.phone && user.verify) {
        setIsInfo(false)
        setIsVerify(false)
        if (
          !isVisibleIntroduce &&
          getIsGuideByKey(GUIDE_TYPE_ENUM.overview) &&
          tourOverview &&
          tourOverview?.length
        ) {
          setTourConfig(tourOverview)
          setIsGuideByKey(GUIDE_TYPE_ENUM.overview)
        }
      }
    }
  }, [user, tourOverview, isVisibleIntroduce])

  // Load share data (business, province, package...)
  useEffect(() => {
    if (!share || !share.business) {
      onWhatYouNeed()
    }
  }, [])

  useEffect(() => {
    if (user?.business && share?.business) {
      let businessList = _.toString(user.business).split(',')
      const data = businessList?.map((b) => {
        return share.business.find((bus) => _.toString(bus.id) === _.toString(b))
      }).filter(Boolean)
      setBusiness(data)
    }
  }, [user?.business, share?.business])

  useEffect(() => {
    if (countries && user?.country) {
      setCountry(user.country)
      setProvince(user?.province)
    }

    if (share?.package && share?.package?.giftPoint) {
      setGiftPoints(share.package.giftPoint)
    }
  }, [user, share, countries])

  function checkAlert() {
    if (localStorage.getItem('alertGiftBox') != null) {
      setIsAlertPoints(false)
    } else {
      setIsAlertPoints(true)
    }
  }

  const handleChange = (key, value) => {
    switch (key) {
      case 'name':
        setName(value)
        break
      case 'phone':
        setPhone(value)
        break
      case 'phoneNumber':
        // Only allow digits inside local phone number area
        setPhoneNumber(value.replace(/\D/g, ''))
        break
      case 'email':
        setEmail(value)
        break
      case 'company':
        setCompany(value)
        break
      case 'province':
        setProvince(value)
        break
      case 'business':
        setBusiness(value)
        break
      case 'country':
        setCountry(value)
        setProvince('')
        break

      default:
        break
    }
  }

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value)
  }

  const providerOptions = useMemo(() => {
    if (country) {
      const countrySelected = countries.find((c) => c.countryName === country)
      if (countrySelected) return countrySelected?.provinces
    }
  }, [country])

  const closeModalIntroduce = () => {
    setIsVisibleIntroduce(false)
    setTourConfig(null)
  }

  const closeAlertPoints = () => {
    setIsAlertPoints(false)
  }

  const closeTour = () => {
    setIsShowDashboardTooltip(true)
    setTourConfig(null)
  }

  const dateRange = {
    LAST_7D: [
      moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DD'),
      moment().subtract(7, 'days').endOf('day').format('YYYY-MM-DD'),
    ],
    LAST_1M: [
      moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
      moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
    ],
    LAST_3M: [
      moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'),
      moment().subtract(3, 'months').endOf('month').format('YYYY-MM-DD'),
    ],
  }

  return (
    <MainLayout>
      <Tour
        steps={tourConfig}
        isOpen={tourConfig != null}
        accentColor="#05ae34"
        closeWithMask={false}
        lastStepNextButton={
          <Button size="small" className="btn--rounder" variant="contained">
            {t('common.btn.close')}
          </Button>
        }
        onRequestClose={closeTour}
      />
      {loading && <Loading />}
      {/* ── Onboarding modal v5 — thay thế form cũ + DialogVerifyPhone ── */}
      <OnboardingModal
        isOpen={isInfo || isVerify}
        user={user}
        share={share}
        updateUser={updateUser}
        onVerifyNumberPhone={onVerifyNumberPhone}
        onVerifyNumberPhoneVoice={onVerifyNumberPhoneVoice}
      />
      <DashboardV2 dashboard={dashboard} campaigns={campaign} user={user} />
      <DailyBannerModal onClickBanner={() => setOpenPricing(true)} />
      {isVisibleIntroduce && (
        <Introduce isVisibleIntroduce handleClose={closeModalIntroduce} />
      )}

      {isAlertPoints && giftPoints > 150 && (
        <DialogAlertPoints
          name={user?.name}
          isAlertPoints
          point={giftPoints}
          handleClose={closeAlertPoints}
        />
      )}
      <MessengerButton />
      <PricingModal 
        open={openPricing} 
        onClose={() => setOpenPricing(false)} 
        user={user} 
        i18n={i18n} 
      />
    </MainLayout>
  )
}

HomeView.propTypes = {}

HomeView.defaultProps = {}

export default HomeView
